import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon';
import {
  NavigationWrapper,
  NavigationOverlay,
  NavigationButton,
  Counter
} from './ImageNavigation.styles';

const ImageNavigation = ({ currentIndex, total, onPrevious, onNext }) => {
  return (
    <NavigationWrapper>
      <NavigationOverlay>
        <NavigationButton onClick={onPrevious}>
          <Icon icon="icon-chevron-left" fontSize="12px" color="#ffffff" />
        </NavigationButton>
        <Counter>{`${currentIndex + 1} / ${total}`}</Counter>
        <NavigationButton onClick={onNext}>
          <Icon icon="icon-chevron-right" fontSize="12px" color="#ffffff" />
        </NavigationButton>
      </NavigationOverlay>
    </NavigationWrapper>
  );
};

ImageNavigation.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default ImageNavigation;
